if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Écoute du changement de variante
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Initialisation
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      // Cas : déjà caché + plus de stock
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      // Définition de l'état d'inventaire
      if (count <= 0) {
        // Rupture ou stock négatif
        if (inventoryPolicy === 'continue') {
          // Épuisé, mais vente autorisée => backordered
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          // Épuisé + deny => sold out => none
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      // Condition globale pour afficher le composant
      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        
        this.hidden = false;
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Récupération des tags si data-product-tags est défini
        let productTags = [];
        const productWrapper = this.closest('[data-product-tags]');
        if (productWrapper) {
          const tagsAttr = productWrapper.getAttribute('data-product-tags');
          if (tagsAttr) {
            productTags = tagsAttr.split(',');
          }
        }

        // --- Choix du message ---

        if (inventoryLevel === 'backordered') {
          /**
           * Cas : stock <= 0 & policy = 'continue'
           * => On force "Sur commande ✓" par défaut,
           *    puis on surchage si un tag est détecté.
           */
          let message = "Sur commande ✓"; 

          if (productTags.includes('1week')) {
            message = "Sur commande ✓ Délai 1-2 semaines";
          } else if (productTags.includes('2weeks')) {
            message = "Sur commande ✓ Délai 2-3 semaines";
          } else if (productTags.includes('3weeks')) {
            message = "Sur commande ✓ Délai 3-4 semaines";
          } else if (productTags.includes('4weeks')) {
            message = "Sur commande ✓ Délai 4-5 semaines";
          } else if (productTags.includes('5weeks')) {
            message = "Sur commande ✓ Délai 5-6 semaines";
          } else if (productTags.includes('6weeks')) {
            message = "Sur commande ✓ Délai 6-8 semaines";
          } else if (productTags.includes('8weeks')) {
            message = "Sur commande ✓ Délai 8-10 semaines";
          } else if (productTags.includes('10weeks')) {
            message = "Sur commande ✓ Délai 10-12 semaines";
          }

          // Affectation finale pour backordered
          this.inventoryNotice.innerText = message;

        } else if (
          inventoryLevel !== 'in_stock'
          && (this.dataset.showCount === 'always'
              || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))
          && inventoryLevel !== 'none'
        ) {
          // only X left
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);

        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock;

        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;

        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;

        } else if (inventoryLevel === 'none') {
          /**
           * Cas : stock <= 0 + 'deny' => sold out
           * => On force "Rupture de stock"
           * (Remplace theme.strings.noStock pour éviter duplication)
           */
          this.inventoryNotice.innerText = "";
        }

        // --- Urgency message ---
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            // Soit on force "Rupture de stock" ou on laisse ?
            this.urgencyMessage.innerHTML = "Rupture de stock"; 
          }
        }

        // --- Mise à jour de la barre d'indicateur ---
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;
          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock')
              && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }

      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
